import {isAndroid, isIOS} from "@src/utils/getBrowser.ts";
import {CommonEventType} from "@src/Store/eventsStore.ts";


export const getLocationLink = (event: CommonEventType) => {
    if (!event) return undefined;
    const coords = `${event.latitude},${event?.longitude}`;
    if (isIOS()) {
        return `maps://?q=${encodeURIComponent(coords)}`;
    }
    if (isAndroid())
        return `geo:${coords}?q=${encodeURIComponent(coords)}`;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(coords)}`;
}

export const getLocationsString = (event: CommonEventType) => {
    if (!event.latitude || !event?.longitude) return "—,—";
    const lang = event.latitude.toFixed(3);
    const long = event.longitude.toFixed(3);
    // @ts-ignore
    return event?.branch_name ?? `${lang},${long}`;
}